module.exports = __webpack_public_path__ + "static/media/clock-loading-retina.19710fee.png";